export const styles = (theme) => ({
  pageHeader: {
    paddingTop: 75,
    marginLeft: 256,
    borderBottom: "1px solid #cac5c5d9",
    boxShadow: "0px 2px 4px #e4e4e4",
    borderLeft: "1px solid #d6d6d6f7",
  },
  tableContainer: {
    padding: 15,
  },
  tableActionButton: {
    padding: 4,
  },
  checkTable: {
    height: 400,
    margin: 10,
  },
  girdContainer: {
    margin: "0px 15px",
  },
  bodyContainer: {
    marginTop: 54,
  }
});
